import { c as _c } from "react/compiler-runtime";
import { WaveLeaderboardGalleryItem } from "@/components/waves/leaderboard/gallery/WaveLeaderboardGalleryItem";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { PREVIEW_CASE_WIDTHS } from "../presentation/presets";
import { PreviewCaseSection } from "./PreviewCaseSection";
import { PreviewWidthFrame } from "./PreviewWidthFrame";
interface PreviewLeaderboardGalleryCaseProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export function PreviewLeaderboardGalleryCase(t0) {
  const $ = _c(3);
  const {
    drop,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onDropClick) {
    t1 = <PreviewCaseSection title="Leaderboard Gallery Card"><PreviewWidthFrame maxWidthClass={PREVIEW_CASE_WIDTHS.leaderboardGalleryItem}><WaveLeaderboardGalleryItem drop={drop} onDropClick={onDropClick} /></PreviewWidthFrame></PreviewCaseSection>;
    $[0] = drop;
    $[1] = onDropClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}